import React, { Component } from "react";
import { notification, Typography } from "antd";

import ErrorContainer from "../modules/error/container";

const { Text } = Typography;

const Description = ({ errors }) => (
  <div className="notification-description">
    {errors?.map((msg, index) => {
      return (
        <p key={index}>
          <Text type="danger">{msg}</Text>
        </p>
      );
    })}
  </div>
);

class AppError extends Component {
  componentDidUpdate(prevProps) {
    const {
      error: { message, errors },
    } = this.props;
    if (message !== prevProps.error.message && message) {
      if (Array.isArray(message)) {
        message.forEach(msg => {
          notification.error({
            message: msg,
            description: errors && <Description errors={errors} />,
            placement: "bottomRight",
            onClose: () => this.props.setError({}),
          });
        });
      } else {
        notification.error({
          message: message,
          description: errors && <Description errors={errors} />,
          placement: "bottomRight",
          onClose: () => this.props.setError({}),
        });
      }
    }
  }
  render() {
    return null;
  }
}

export default ErrorContainer(AppError);
